module.exports = __webpack_public_path__ + "static/media/profile-icon.43600e97.svg";